const StatsSection = () => {
  const stats = [
    { number: '110+', label: 'Years of Excellence' },
    { number: '500+', label: 'Fleet Vehicles' },
    { number: '10K+', label: 'Satisfied Clients' },
    { number: '99.8%', label: 'On-Time Delivery' },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-[#FFF8F0] to-[#FFE5D4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-[#FF8C42] mb-2">
                {stat.number}
              </div>
              <div className="text-lg text-[#2A2A2A] font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;